import { Range, RangeValue } from './types';

export const extractRangeFromPayload = (
  from: number | null,
  to: number | null,
  fallback: RangeValue,
): Range => ({
  range: {
    min: from ?? fallback.min,
    max: to ?? fallback.max,
  },
  minValue: fallback.min,
  maxValue: fallback.max,
});

export const buildRange = (
  from: number | null,
  to: number | null,
  fallback?: RangeValue,
): Range => extractRangeFromPayload(from, to, fallback ?? { min: null, max: null });
